// Analytics + visitor tracking API (Phase 5).
import { api } from './client';
import { USE_MOCK_API } from '../http';
import { getRawAnalytics } from '../admin.mock';

export type AnalyticsDataset = {
  orders: any[];
  items: any[];
  products: any[];
  visits: any[];
};

export const analyticsApi = {
  // Public: fire-and-forget visit tracking (never throws). Sent once per
  // browsing session (not per refresh / navigation) to minimise writes.
  track(visitor_id: string, path: string, session_id?: string): Promise<unknown> {
    return api('/track', { method: 'POST', body: { visitor_id, path, session_id } }).catch(() => undefined);
  },

  // Admin: lightweight orders dataset for the overview KPIs.
  overview(): Promise<{ items: any[] }> {
    return api('/admin/orders', { auth: true });
  },

  // Admin: full analytics datasets (client aggregates with date filters).
  get(): Promise<AnalyticsDataset> {
    if (USE_MOCK_API) return getRawAnalytics();
    return api('/admin/analytics', { auth: true });
  },

  // Admin: permanently clear visitor analytics.
  clearVisits(): Promise<{ ok: true }> {
    return api('/admin/visits', { method: 'DELETE', auth: true });
  },
};
